var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.729,
    height: 26.145,
    viewBox: "0 0 20.729 26.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-pin",
    transform: "translate(-5.627 -1.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5541",
    "data-name": "Pfad 5541",
    d: "M16.615,8.971A3.225,3.225,0,1,0,19.877,12.2,3.243,3.243,0,0,0,16.615,8.971Zm0,4.837A1.612,1.612,0,1,1,18.246,12.2a1.622,1.622,0,0,1-1.631,1.612Z",
    transform: "translate(-0.624 -1.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5542",
    "data-name": "Pfad 5542",
    d: "M23.319,4.082A10.878,10.878,0,0,0,9.464,3.408,9.311,9.311,0,0,0,7.306,16.259l7.205,10.372a1.831,1.831,0,0,0,2.958,0l7.206-10.372A9.27,9.27,0,0,0,23.32,4.082Zm-.242,11.2-7.086,10.2L8.9,15.283A7.6,7.6,0,0,1,10.01,5.347a8.86,8.86,0,0,1,11.961,0A7.6,7.6,0,0,1,23.077,15.283Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.9c6f561f0407d54d577d4853dd5e980d.svg";
export { ForwardRef as ReactComponent };